var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.236 16.8357C24.216 14.4226 19.3185 16.4588 17.2916 19.8657C13.1516 26.7713 20.9497 39.1313 21.1691 39.2513",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5939 22.4419C41.6139 24.855 42.1239 30.1238 40.0783 33.525C35.9439 40.4138 21.3696 39.3656 21.1689 39.2513",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6558 21.7313C31.3746 20.2294 30.5177 18.2157 28.2358 16.8357",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6553 21.7313C33.1121 21.2626 35.2928 21.0563 37.5934 22.4419",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4055 16.0556C26.9886 14.4656 27.1948 12.8269 26.8161 11.2594C25.9798 7.84876 22.4005 4.83751 18.3674 5.81063C16.0667 6.37313 14.8124 7.85438 14.188 9.04126C13.063 8.25751 11.2817 7.52438 8.97923 8.08688C4.94423 9.06188 3.11423 13.3613 3.95048 16.7719C5.18423 21.8925 12.3655 24.8419 16.1286 26.0138",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationHearts);
export default __webpack_public_path__ + "static/media/navigation-hearts.a222294d.svg";
export { ForwardRef as ReactComponent };